const moduleName: string = "AUTHENTICATION/";

export const LOGIN_START: string = `${moduleName}LOGIN_USER_START`;
export const LOGIN_SUCCESS: string = `${moduleName}LOGIN_USER_SUCCESS`;
export const LOGIN_ERROR: string = `${moduleName}LOGIN_USER_ERROR`;